import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { User } from '@lemsar/auth/domains/models/user';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { LemsarApiClient } from '@lemsar/api/client';
import { catchError, map, switchMap } from 'rxjs/internal/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NacoService } from '@naker/naco';
import { fromPromise } from 'rxjs/internal/observable/fromPromise';
import { of } from 'rxjs/index';
import { AuthStore } from '@lemsar/storage/stores/auth.store';

@Injectable()
export class AuthService {
    public registered: boolean;

    public constructor(private api: LemsarApiClient, private naco: NacoService, private injector: Injector) {}

    public getUser(): Observable<any> {
        return this.api.get<any>('users/me').pipe(
            <any>ResponseTransformer.toData(),
            <any>ResponseTransformer.toSingleClass(User),
            catchError((e: HttpErrorResponse) => {
                if (401 === e.status || 403 === e.status) {
                    return fromPromise(this.authStore().clear()).pipe(map(() => null));
                }

                return of(null);
            }),
        );
    }

    public getRegisteredUser(): Observable<any> {
        return fromPromise(this.naco.getSignature()).pipe(
            switchMap((signature: any) => {
                if (null !== signature) {
                    return this.api.get<any>('users/naco').pipe(
                        ResponseTransformer.toData(),
                        catchError((e: HttpErrorResponse) => {
                            if (401 === e.status || 403 === e.status) {
                                return fromPromise(this.authStore().clear()).pipe(map(() => null));
                            }

                            return of(null);
                        }),
                    );
                }

                return of(null);
            }),
        );
    }

    public isRegistered(): Observable<boolean> {
        return this.getRegisteredUser().pipe(
            map((user: any) => {
                if (user instanceof Array && !user.length) {
                    return false;
                }

                return !!user;
            }),
        );
    }

    public activateUser(activationCode: string): Observable<any> {
        return this.api.patch('activate-user', { activationCode });
    }

    public authStore(): AuthStore {
        return this.injector.get(AuthStore);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/domains/services/auth.service.ts